module.exports = __webpack_public_path__ + "img/setup-1.e330dd0d.png";